import { postMethodWithTokenWithLatLng } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const CREATE_SPECIALIST_PROVIDER = 'CREATE_SPECIALIST_PROVIDER';
export const CREATE_SPECIALIST_PROVIDER_SUCCESS =
  'CREATE_SPECIALIST_PROVIDER_SUCCESS';
export const CREATE_SPECIALIST_PROVIDER_FAILURE =
  'CREATE_SPECIALIST_PROVIDER_FAILURE';

// Action Creators
export const fetchCreateSpecialistProvider = () => ({
  type: CREATE_SPECIALIST_PROVIDER,
});

export const fetchCreateSpecialistProviderSuccess = (data) => ({
  type: CREATE_SPECIALIST_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchCreateSpecialistProviderFailure = (error) => ({
  type: CREATE_SPECIALIST_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const createSpecialistProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchCreateSpecialistProvider(data, external));
    try {
      const response = await postMethodWithTokenWithLatLng(
        url.createSpecialistProvider,
        data,
        external?.latlng
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchCreateSpecialistProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchCreateSpecialistProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchCreateSpecialistProviderFailure(error.message));
    }
  };
};
